"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayPortalContainer = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var OverlayPortalContainer = exports.OverlayPortalContainer = _styledComponents["default"].div.withConfig({
  displayName: "Container__OverlayPortalContainer",
  componentId: "sc-1vwgkyp-0"
})(["position:fixed;", " pointer-events:none;z-index:", ";"], function (props) {
  var _props$$overlayPositi = props.$overlayPosition,
    top = _props$$overlayPositi.top,
    left = _props$$overlayPositi.left,
    width = _props$$overlayPositi.width,
    height = _props$$overlayPositi.height;
  return "\n      top: ".concat(top, "px;\n      left: ").concat(left, "px;\n      width: ").concat(width, "px;\n      height: ").concat(height, "px;\n    ");
}, _index.zIndexPopover);